import * as React from 'react';
import layoutStyles from '../styles/components/layout.module.scss';
import PageTitle from './pageTitle';
import { NavBar, NavBarItem } from './navBar';

export default class Layout extends React.Component {

    private navItems: NavBarItem[] = [
        {name: 'about', location: '/about'},
        {name: 'portfolio', location: '/portfolio'},
        {name: 'contact', location: '/contact'}
    ];

    public render() {

        const component =
        <div>
            <header className={layoutStyles.header}>
                <PageTitle headerClassName={layoutStyles.pageTitle}/>
                <NavBar navBarItems={this.navItems} navBarClassName={layoutStyles.navBar}/>
            </header>
            <div className={layoutStyles.pageLine}>
                <div className={layoutStyles.line} />
                <div className={layoutStyles.circle} />
                <div className={layoutStyles.line} />
            </div>

            <div className={layoutStyles.content}>
                {this.props.children}
            </div>

            <footer>
            </footer>
        </div>;

        return component;
    }
}
